module.exports = __webpack_public_path__ + "img/image.6d3e18fa.svg";